import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetViewAdmin = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_ALLOWS_ADMIN
            });
            const Allows = data.data.allow.split(',');

            if (data.status === 'success') {
                dispatch(Action.SetGetViewAdminAction({
                    InformationPanel: Allows?.includes('InformationPanel'),
                    FinanceReport: Allows?.includes('FinanceReport'),
                    BonusesReport: Allows?.includes('BonusesReport'),
                    JackpotReport: Allows?.includes('JackpotReport'),
                    BalanceReport: Allows?.includes('BalanceReport'),
                    EventReport: Allows?.includes('EventReport'),
                    Jackpot: Allows?.includes('Jackpot'),
                    Tournament: Allows?.includes('Tournament'),
                    Lottery: Allows?.includes('Lottery'),
                    Referral: Allows?.includes('Referral'),
                    CreditLine: Allows?.includes('CreditLine'),
                    HistoryReplenishment: Allows?.includes('HistoryReplenishment'),
                    ReportProvider: Allows?.includes('ReportProvider'),
                    GamesSearch: Allows?.includes('GamesSearch'),
                    PaymentSystem: Allows?.includes('PaymentSystem'),
                    Withdrawals: Allows?.includes('Withdrawals'),
                    WithdrawalsOperations: Allows?.includes('WithdrawalsOperations'),
                    GamerReport: Allows?.includes('GamerReport'),
                    ReplenishmentReport: Allows?.includes('ReplenishmentReport'),
                    Gamer: Allows?.includes('Gamer'),
                    Kyc: Allows?.includes('Kyc'),
                    Bonuses: Allows?.includes('Bonuses'),
                    PersonalBonuses: Allows?.includes('PersonalBonuses'),
                    PresentConfirmation: Allows?.includes('PresentConfirmation'),
                    Freespin: Allows?.includes('Freespin'),
                    CashierUsers: Allows?.includes('CashierUsers'),
                    CashierReport: Allows?.includes('CashierReport'),
                    CashierFinance: Allows?.includes('CashierFinance'),
                    CashierGroup: Allows?.includes('CashierGroup'),
                    Support: Allows?.includes('Support'),
                    SecurityAdmin: Allows?.includes('SecurityAdmin'),
                    SecurityHistorySignin: Allows?.includes('SecurityHistorySignin'),
                    SecurityHistoryEvent: Allows?.includes('SecurityHistoryEvent'),
                    UserBlock: Allows?.includes('UserBlock'),
                    ChangePassword: Allows?.includes('ChangePassword'),
                    ManagementBalance: Allows?.includes('ManagementBalance'),
                    JackpotIssue: Allows?.includes('JackpotIssue'),
                    SettingsMessanger: Allows?.includes('SettingsMessanger'),
                    SettingsExchange: Allows?.includes('SettingsExchange'),
                    SettingsCodeCountry: Allows?.includes('SettingsCodeCountry'),
                    SettingsCurrency: Allows?.includes('SettingsCurrency')
                }));
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetViewAdmin as SetGetViewAdmin
}